import React from 'react';
import { useLocation } from 'react-router-dom';
import AppRoutes from '@/presentation/routing/AppRoutes';
import { useUserWorkspaceStore } from '@/presentation/workspace/useUserWorkspaceStore';
import { installGlobalQuizBgm, setGlobalQuizBgmRouteEnabled } from '@/utils/globalQuizBgm';

export default function App() {
  const theme = useUserWorkspaceStore((s) => s.theme);
  const location = useLocation();

  React.useEffect(() => {
    const html = document.documentElement;
    if (theme === 'dark') {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
  }, [theme]);

  React.useEffect(() => installGlobalQuizBgm(), []);

  React.useEffect(() => {
    const p = location.pathname || '/';
    const enabled =
      p.startsWith('/dashboard') ||
      p.startsWith('/quizzes') ||
      p.startsWith('/account') ||
      p.startsWith('/settings') ||
      p.startsWith('/history') ||
      p.startsWith('/notifications') ||
      p.startsWith('/play/') ||
      p.startsWith('/public-quizzes/');
    setGlobalQuizBgmRouteEnabled(enabled);
  }, [location.pathname]);

  return <AppRoutes />;
}

